import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { RepeatableFormRows } from '@shared/components/form/repeatable-form-rows';
import { FormMessage } from '@shared/components/ui/form';
import { Skeleton } from '@shared/components/ui/skeleton';
import { useFormContext } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import { DistributionFlowContext } from '../distribution-flow-layout';
import DistributionFlowRow from './distribution-flow-row';

export default function DistributionFlowForm() {
  const { getFieldState } = useFormContext();
  const context = useOutletContext<DistributionFlowContext>();
  const { flowUuid, loadingFlow } = context;
  const fieldState = getFieldState('segments');

  return (
    <div>
      {flowUuid && loadingFlow ? (
        <div className="space-y-2">
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
          <Skeleton className="h-12 w-full rounded-md bg-gray-100" />
        </div>
      ) : (
        <RepeatableFormRows
          name="segments"
          component={DistributionFlowRow}
          showAddButton={false}
          newRowObject={{
            storageManagedBy: 'company',
            nodeType: '',
            transportMode: '',
            distance: '',
            transportManagedBy: '',
            storageDuration: '',
          }}
        />
      )}

      <div className="mt-2 flex h-[60px] w-[700px] items-center space-x-3 rounded-md border-2 border-primary-100 bg-gray-00 px-4 py-2">
        <Icons.salad className="size-6 text-gray-200" />
        <div className="flex w-full space-x-2">
          <Text className="text-gray-200">Consumer</Text>
        </div>
      </div>

      <FormMessage>{fieldState.error?.message}</FormMessage>
    </div>
  );
}
